import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useFeed(cityId, filter = 'todos') {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [cursor, setCursor] = useState(null);

  const fetchPosts = useCallback(async (reset = false) => {
    if (!cityId) return;
    setLoading(true);
    setError(null);
    try {
      const params = { city_id: cityId, limit: 20 };
      if (filter && filter !== 'todos') params.type = filter;
      if (!reset && cursor) params.cursor = cursor;

      const { data } = await api.get('/feed', { params });

      const list = data.posts || data.data || (Array.isArray(data) ? data : []);
      setPosts(prev => reset ? list : [...prev, ...list]);
      setHasMore(data.hasMore || data.pagination?.hasMore || false);
      if (data.nextCursor) setCursor(data.nextCursor);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erro ao carregar feed');
    } finally {
      setLoading(false);
    }
  }, [cityId, filter, cursor]);

  useEffect(() => {
    if (cityId) fetchPosts(true);
  }, [cityId, filter]); // eslint-disable-line

  const loadMore = useCallback(() => {
    if (hasMore && !loading) fetchPosts(false);
  }, [hasMore, loading, fetchPosts]);

  return { posts, loading, error, hasMore, loadMore, refetch: () => fetchPosts(true) };
}
